import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'promise-polyfill/src/polyfill'
import allSettled from 'promise.allsettled' // will be a no-op if not needed
import App from './App'
import * as serviceWorker from './RegisterServiceWorker'
import './i18n'
import SimpleLoader from './components/Loaders/SimpleLoader'
import IntegrationProvider from './components/IntegrationProvider'

allSettled.shim()

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<SimpleLoader label="Initializing the application" />}>
      <IntegrationProvider>
        <App />
      </IntegrationProvider>
    </Suspense>
  </React.StrictMode>,

  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
